import getCookie from "./getCookies";

// Admins allowed to use dev/admin-only tools (e.g. prep dev tools) on production, in
// addition to anyone in a local development build. Keep in sync with the server's
// DEV_TOOLS_ADMIN_EMAILS (AONE-Universe-server/lib/constants.js) — the server is the
// real gate; this list only controls whether the UI renders.
export const DEV_TOOLS_ADMIN_EMAILS = [
    "kyesung8282@gmail.com",
    "hyunjekim2000@gmail.com",
    "hyunjekim0308@gmail.com",
];

// True if `email` is a dev-tools admin (case-insensitive).
export const isDevToolsAdmin = (email) =>
    DEV_TOOLS_ADMIN_EMAILS.includes(String(email || "").toLowerCase());

// Email of the signed-in user, read from the react-auth-kit `_auth_state` cookie
// ({ id, email, who }). Returns "" if absent/unparseable.
export const currentUserEmail = () => {
    try {
        const raw = getCookie("_auth_state");
        return raw ? String(JSON.parse(raw)?.email || "").toLowerCase() : "";
    } catch {
        return "";
    }
};

// Dev tools are available in a local development build, or to an allowlisted admin in
// any environment.
export const canUseDevTools = () =>
    process.env.NODE_ENV === "development" || isDevToolsAdmin(currentUserEmail());
